import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MOMENT_DATE_FORMAT } from '@app/_helpers';
import { DOWNGRADE_CONFIRMATION, PLAN_UNSUBSCRIBE } from '@app/_shared/strings';
import * as moment from 'moment';

@Component({
  selector: 'app-payment-confirmation',
  templateUrl: './payment-confirmation.component.html',
  styleUrls: ['./payment-confirmation.component.scss']
})
export class PaymentConfirmationComponent implements OnInit {

  isUnsubscribe: boolean;
  isSuccess: boolean = false;
  amount: number;
  planName: string;
  validity: string;
  downgrade: boolean;
  PLAN_UNSUBSCRIBE = PLAN_UNSUBSCRIBE;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<PaymentConfirmationComponent>,
  ) {
    this.amount = 200.00;
  }

  ngOnInit(): void {
    this.isUnsubscribe = this.data.isUnsubscribe;
    this.planName = this.data.planName;
    this.validity = moment(this.data.validity).format(MOMENT_DATE_FORMAT);
    this.downgrade = !!this.data?.downgrade;

    if (this.downgrade) {
      this.PLAN_UNSUBSCRIBE = DOWNGRADE_CONFIRMATION;
    }
  }

  closeDialog(success = false) {
    this.dialogRef.close(success);
  }
}
